import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export interface PaylinkOrderRequest {
  order: {
    number: string;
    type: string;
    qrPayment: boolean;
    country: {
      code: string;
    };
    currency: {
      code: string;
    };
    merchantStoreCode?: string;  // Opcional
    amountEntryIndicator: boolean;
    amount: number;
    discounts: number;
    taxes: number;
    fee: number;
    shippingAmount: number;
    dispatch: string;
    products: Array<{
      name: string;
      quantity: number;
      unitAmount: number;
      amount: number;
      sku: string;
      category: string;
      discount: number;
      shipping: number;
    }>;
    multipleCustomerIndicator: boolean;
    customer: {
      identifier: string;
      name: string;
      lastName: string;
      phone: string;
      email: string;
      document: {
        type: string;
        number: string;
      };
      address: {
        country: string;
        levels: string[];
        line1: string;
        zip: string;
      };
    };
    metadata: any[];
  };
  settings: {
    expiration: {
      type: string;
      date: string;
    };
    language: string;
  };
}

export interface PaylinkOrderResponse {
  success: boolean;
  message: {
    code: string;
    text: string;
  };
  data: {
    order: {
      number: string;
      type: string;
      identifier: string;
      uniqueIdentifier: string;
      link: string;
      qrLink: string;
      state: string;
      amount: number;
      entity: {
        identifier: string;
      };
      currency: {
        code: string;
      };
      [key: string]: any;
    };
    settings: {
      expiration: {
        type: string;
        date: string;
      };
      language: string;
    };
  };
}

@Injectable({
  providedIn: 'root'
})
export class PaylinkService {

  constructor(private readonly http: HttpClient) { }

  static readonly API_URLS: Record<string, string> = {
    QA: 'https://qas.api.epago.pe',
    DEV: 'https://dev.api.epago.pe',
  };

  createOrder(
    orderData: PaylinkOrderRequest,
    identifier: string,
    signature: string,
    signedElement: string,
    environment: string = 'QA',
    ): Observable<PaylinkOrderResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'identifier': identifier,
        'signature': signature,
        'signedElement': signedElement,
        'transaction-id': identifier
      })
    };

    const baseUrl = PaylinkService.API_URLS[environment] ?? PaylinkService.API_URLS['QA'];
    const url = `${baseUrl}/orders/create`;
    
    return this.http.post<PaylinkOrderResponse>(url, orderData, httpOptions);
  }

  abortOrder(orderId: string, merchantCode: string, orderIdentifier: string, environment: string = 'QA'): Observable<any> {
    const baseUrl = PaylinkService.API_URLS[environment] ?? PaylinkService.API_URLS['QA'];
    const url = `${baseUrl}/payment/engine/orders/abort2/paymentId/${encodeURIComponent(orderId)}/merchantCode/${encodeURIComponent(merchantCode)}?transactionId=${encodeURIComponent(orderIdentifier)}`;
    return this.http.get<any>(url, { observe: 'response' });
  }
}

